/* ============================================================
   Offre "Un autocollant offert" — comportement (préfixe go-)
   Config injectée par snippets/gift-offer.liquid : window.GO_CONFIG
   { collectionUrl, gifts: [{handle, variant, title, img, url}] }
   ============================================================ */
(function () {
  'use strict';
  var CFG = window.GO_CONFIG;
  if (!CFG || !CFG.gifts || !CFG.gifts.length) return;

  var PATH = window.location.pathname;
  var LS_KEY = 'go_popup_v1';

  /* ---------- 1. Badges "OFFERT" sur les cards produit ---------- */
  function decorateCards(root) {
    CFG.gifts.forEach(function (g) {
      var links = (root || document).querySelectorAll('a[href*="/products/' + g.handle + '"]');
      for (var i = 0; i < links.length; i++) {
        var card = links[i].closest('.product-item');
        if (!card || card.dataset.goBadged) continue;
        card.dataset.goBadged = '1';
        var list = card.querySelector('.product-item__label-list');
        if (!list) {
          list = document.createElement('div');
          list.className = 'product-item__label-list';
          var wrap = card.querySelector('.product-item__image-wrapper');
          if (wrap && wrap.parentNode) wrap.parentNode.insertBefore(list, wrap);
          else card.insertBefore(list, card.firstChild);
        }
        if (list.querySelector('.go-badge')) continue;
        var badge = document.createElement('span');
        badge.className = 'product-label go-badge';
        badge.textContent = 'OFFERT dès 1 achat';
        badge.title = "Ajoutez-le à votre panier avec votre commande : il passe automatiquement à 0 €. Offre réservée aux 200 premières commandes.";
        list.appendChild(badge);
      }
    });
  }

  /* Grilles chargées/paginées en AJAX : on observe le DOM (léger). */
  function watchGrids() {
    decorateCards(document);
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { decorateCards(document); break; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- 2. Note sur les pages produit des 5 cadeaux ---------- */
  function pdpNote() {
    var gift = null;
    for (var i = 0; i < CFG.gifts.length; i++) {
      if (PATH.indexOf('/products/' + CFG.gifts[i].handle) !== -1) { gift = CFG.gifts[i]; break; }
    }
    if (!gift || document.querySelector('.go-pdp-note')) return;
    var note = document.createElement('div');
    note.className = 'go-pdp-note';
    note.innerHTML = '<span class="go-pdp-note__icon">🎁</span><span><strong>Cet autocollant vous est OFFERT dès 1 article acheté.</strong> ' +
      'Ajoutez-le à votre panier en plus de votre commande : il passe automatiquement à 0 €. Offre réservée aux 200 premières commandes.</span>';
    var anchor = document.querySelector('.product-form') || document.querySelector('.product-meta');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(note, anchor);
  }

  /* ---------- 3. Popup première visite ---------- */
  function popup() {
    if (PATH.indexOf('/cart') === 0 || PATH.indexOf('/checkout') === 0 || PATH.indexOf('/account') === 0) return;
    if (PATH.indexOf('/collections/autocollant-offert') === 0) return;
    try { if (window.localStorage.getItem(LS_KEY)) return; } catch (e) { return; }

    var overlay = document.querySelector('.go-overlay');
    var pop = document.querySelector('.go-popup');
    if (!overlay || !pop) return;

    function close() {
      overlay.classList.remove('go-visible');
      pop.classList.remove('go-visible');
      try { window.localStorage.setItem(LS_KEY, String(Date.now())); } catch (e) {}
    }
    overlay.addEventListener('click', close);
    pop.querySelector('.go-popup__close').addEventListener('click', close);
    var cta = pop.querySelector('.go-popup__cta');
    if (cta) cta.addEventListener('click', function () {
      try { window.localStorage.setItem(LS_KEY, String(Date.now())); } catch (e) {}
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    window.setTimeout(function () {
      overlay.classList.add('go-visible');
      pop.classList.add('go-visible');
      var btn = pop.querySelector('.go-popup__close');
      if (btn) btn.focus({ preventScroll: true });
    }, 3500);
  }

  /* ---------- 4. Ajout du cadeau depuis le drawer panier ---------- */
  /* Le drawer est dans un <form> : les boutons sont en type=button et on passe
     par l'API AJAX, puis on emmene le client sur la page panier (ou il voit la
     ligne a 0 € et le bouton commander). Delegation : survit aux re-rendus. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.go-mini__add');
    if (!btn || btn.dataset.goBusy) return;
    e.preventDefault();
    btn.dataset.goBusy = '1';
    btn.classList.add('go-mini__add--busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = '/cart';
    }).catch(function () {
      delete btn.dataset.goBusy;
      btn.classList.remove('go-mini__add--busy');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watchGrids(); pdpNote(); popup(); });
  } else {
    watchGrids(); pdpNote(); popup();
  }
})();
